<template>
    <div
        style="
            width: 100%;
            background: #fff;
            position: sticky;
            top: 0;
            z-index: 99;
        "
    >
        <div class="newTopFixed fr-ac-jsb">
            <div class="left fr-ac" @click="toProvince">
                <img v-if="logo" src="@/assets/images/newlogoh.png" alt="" class="mr-35"/>
                <img
                    src="https://file.gkzzd.cn/www/gkzzd/uploads/20241018/67915fb0317632bf5decf4a0b302e4ce.png"
                    alt=""
                    class="headerLeftImg"
                />
                <div class="leftProvince" style="font-size: 15px">
                    {{ province }}<i class="el-icon-caret-bottom"></i>
                </div>
            </div>
            <div class="right fr-ac">
                <div class="fr-ac mt-4">
                    <div
                        v-for="(item, ind) in fixedList"
                        :key="ind"
                        class="ml-20 mr-20"
                        :class="
                            fixedIndex == ind ? 'fixedItemActive' : 'fixedItem'
                        "
                        @click="fixedClick(item, ind)"
                        style="font-size: 15px"
                    >
                        {{ item.name }}
                    </div>
                </div>
                <div
                    class="fr-ac mr-20"
                    v-if="isShow"
                    :class="isIndex ? 'pointer' : ''"
                    @click="showPopup()"
                >
                    <div>
                        {{ userInfo.first_subject
                        }}{{
                            userInfo.second_subject
                                ? "," + userInfo.second_subject
                                : ""
                        }}
                        {{
                            userInfo.fs == 0 || userInfo.fs
                                ? userInfo.fs + "分"
                                : "--分"
                        }}
                        {{ userInfo.pm ? userInfo.pm + "名" : "--名" }}
                    </div>
                </div>
                <el-popover
                    placement="bottom"
                    width="200"
                    trigger="click"
                    v-if="is_userInfo"
                >
                    <div class="pointer mb-10" @click="edituserInfo">
                        身份信息
                    </div>
                    <div class="pointer" @click="exit">退出</div>
                    
                    <div slot="reference" class="fr-ac">
                        <img class="logo" :src="userInfo.head_image"/>
                        <div class="ml-5">{{ userInfo.phone }}</div>
                    </div>
                </el-popover>
                <div class="ml-10 rightLogin" @click="isLogin = true" v-else>
                    登录/注册
                </div>
            </div>
        </div>
        <div class="province_pop_up fr-ac-jc" v-if="selectProvince">
            <ProvinceView
                :provincelist="provincelist"
                @closeProvince="closeProvince"
            ></ProvinceView>
        </div>
        <div class="province_pop_up fr-ac-jc" v-if="isLogin">
            <LoginView @login="toLogin" @close="toClose"></LoginView>
        </div>
        <div class="province_pop_up fr-ac-jc" v-if="dialogList.isTrue">
            <DialogView
                :dialogList="dialogList"
                @remove="remove"
                @userSeve="userSeve"
                @userEdit="userEdit"
                @userCancel="userCancel"
            />
        </div>
    </div>
</template>
<script>
import ProvinceView from "@/components/provinceView.vue";
import LoginView from "@/components/loginView.vue";
import { getCookie, setCookie } from "@/utils/common";
import store from "@/store/index";
import { mapState } from 'vuex';
export default {
    name: "newTopFixed",
    props: {
        active: Number,
        isIndex: Boolean,
        isShow: Boolean,
        is_login: Boolean,
        headerProvince: String,
        logo:Boolean
    },
    components: {
        ProvinceView,
        LoginView,
    },
    computed: {
        ...mapState({
            SETUSERINFO: state => state.user.info
        })
    },
    data(props) {
        return {
            province: getCookie("province"),
            userInfo: {},
            fixedList: [
                {
                    id: 1,
                    name: "首页",
                    path: "/",
                    is_open: true,
                    is_vip: true,
                    business: "",
                },
                {
                    id: 2,
                    name: "查大学",
                    path: "/fill/fill_school",
                    is_open: false,
                    is_vip: false,
                    business: "五查系统",
                },
                {
                    id: 3,
                    name: "查专业",
                    path: "/fill/fill_speciality",
                    is_open: false,
                    is_vip: false,
                    business: "五查系统",
                },
                {
                    id: 4,
                    name: "查试卷",
                    path: "/fill/fill_paper",
                    is_open: false,
                    is_vip: false,
                    business: "五查系统",
                },
                {
                    id: 5,
                    name: "选科系统",
                    path: "/fill/fill_optional",
                    is_open: false,
                    is_vip: true,
                    business: "选科系统",
                },
                {
                    id: 6,
                    name: "模拟填报",
                    path: "/fill/fill_index",
                    is_open: false,
                    is_vip: false,
                    business: "模拟填报",
                },
            ],
            fixedIndex: props.active,
            selectProvince: false,
            isLogin: false,
            provincelist: {
                width: "800px",
            },
            is_userInfo: false,
            dialogList: {
                type: "A",
                isTrue: false,
                province: "",
                title: "完善信息",
                //按钮名称
                button: "",
                //按钮
                save: true,
                remove: false,
                cancel: false,
                //禁用
                disabled: false,
                disabledEdit: false,
                //用户信息
                crowd: "",
                candidates_identity: "",
                graduation: "",
                school_city: "",
                school_province: "",
                school_type: "",
                middle_school: "",
                width: "50%",
                showClose: false,
            },
            improveInfo: {},
            provinceId: "",
        };
    },
    watch: {
        SETUSERINFO(newInfo, oldInfo) {
            this.userInfo=newInfo 
        },
        headerProvince: {
            handler(newVal) {
                if (newVal != "") {
                    this.province = newVal;
                    this.getJurisdiction();
                }
            },
            immediate: true,
        },
        province: {
            handler(newVal) {
                if (this.$route.path == '/school/article') {
                    return
                }
                if (newVal == "") {
                    this.$router.push("/");
                }
            },
            immediate: true,
        },
        is_login: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    this.isLogin = newVal;
                }
            },
        },
    },
    methods: {
        showPopup() {
            if (this.isIndex) {
                this.$emit("showPopup");
            }
        },
        async edituserInfo() {
            const res = await this.$http.fetch("api/user/getUserAuthInfo", {});
            if (res.status === 200) {
                this.improveInfo = res.data;
                let crowd = res.data.crowd;
                this.dialogList = {
                    type: "A",
                    isTrue: true,
                    province: "",
                    title: "身份信息",
                    button: "",
                    save: false,
                    remove: true,
                    cancel: false,
                    disabled: true,
                    disabledEdit: false,
                    crowd: crowd == 1 ? "学生" : crowd == 2 ? "家长" : "",
                    candidates_identity: res.data.candidates_identity,
                    graduation: res.data.graduation,
                    school_city: res.data.school_city,
                    school_province: res.data.school_province,
                    school_type: res.data.school_type,
                    middle_school: res.data.middle_school,
                    width: "50%",
                };
            }
        },
        exit() {
            localStorage.clear(); //清除本地缓存
            this.$store.commit("CLEARDATA"); //清除vuex数据
            document.cookie = `${"province"}=; Max-Age=0; path=/;`;
            document.cookie = `${"province_id"}=; Max-Age=0; path=/;`;
            location.reload();
        },
        toProvince() {
            if (store.state.user.token) {
                if (store.state.user.info.isWhite) {
                    this.selectProvince = true;
                }
            } else {
                this.selectProvince = true;
            }
        },
        fixedClick(val, ind) {
            if (val.is_open) {
                if (val.is_vip) {
                    this.fixedIndex = ind;
                    this.$router.push({ path: val.path });
                } else {
                    if (store.state.user.token) {
                        this.dialogList = {
                            type: "C",
                            isTrue: true,
                            province: this.province,
                            save: true,
                            title: `您暂未开通【${val.business}】功能，开通系统即可体验`,
                            button: "开通",
                            width: "30%",
                            showClose: true,
                        };
                    } else {
                        this.isLogin = true;
                        this.$message.error("请先登录");
                    }
                }
            } else {
                this.dialogList = {
                    type: "C",
                    isTrue: true,
                    province: "",
                    save: true,
                    title: `当前省份未开放【${val.business}】功能，敬请期待！`,
                    button: "确定",
                    width: "30%",
                    showClose: true,
                };
            }
        },
        async closeProvince(val1, val2) {
            this.selectProvince = false;
            this.province = val1;
            if (this.is_userInfo) {
                const res = await this.$http.fetch("api/user/changeProvince", {
                    province: val1,
                });
                if (res.status === 200) {
                    this.getUserInfo();
                    this.$emit("closeHeadersf", val1, val2);
                }
            } else {
                this.$emit("closeHeadersf", val1, val2);
                this.getJurisdiction();
            }
        },
        toLogin() {
            this.isLogin = false;
            this.is_userInfo = true;
            this.getUserInfo();
        },
        toClose() {
            this.isLogin = false;
        },
        remove() {
            this.dialogList.isTrue = false;
        },
        async userSeve(val) {
            const res = await this.$http.fetch(
                "/api/user/completeUserInfo",
                val
            );
            if (res.status === 200) {
                this.getUserInfo();
                this.dialogList.isTrue = false;
            } else {
                this.$message.error(res.msg);
            }
        },
        async getUserInfo() {
            const res = await this.$http.fetch("/api/login/getUserInfo", {});
            if (res.status === 200) {
                this.$store.dispatch("user/setUserInfo", res.data);
                this.userInfo = res.data;
                this.province = this.userInfo.sf;
                this.provinceId = this.userInfo.province_id;
                this.$emit("closeHeadersf", this.province, this.provinceId);
                setCookie("isTourist", 1, 7);
                setCookie("province", this.province, 7);
                setCookie("province_id", this.provinceId, 7);

                if (this.userInfo.is_update == 1) {
                    this.dialogList.isTrue = true;
                }
                this.getJurisdiction();
            } else {
                this.$message.error(res.msg);
            }
        },
        async getJurisdiction() {
            const res = await this.$http.fetch("api/homepage/index", {
                sf: this.province,
            });
            if (res.status == 200) {
                this.$store.dispatch("user/setHomePage", res.data);
                this.$emit("getHomePage", res.data);
                this.fixedList[1].is_open = res.data.wucha.is_open;
                this.fixedList[1].is_vip = res.data.wucha.is_vip;
                this.fixedList[2].is_open = res.data.wucha.is_open;
                this.fixedList[2].is_vip = res.data.wucha.is_vip;
                this.fixedList[3].is_open = res.data.wucha.is_open;
                this.fixedList[3].is_vip = res.data.wucha.is_vip;
                this.fixedList[4].is_open = res.data.xuanke.is_open;
                this.fixedList[5].is_open = res.data.moni.is_open;
                this.fixedList[5].is_vip = res.data.moni.is_vip;
            }
        },
        userEdit() {
            this.dialogList = {
                type: "A",
                isTrue: true,
                province: "",
                title: "完善信息",
                button: "",
                save: false,
                remove: false,
                cancel: true,
                disabled: false,
                disabledEdit: true,
                crowd: "",
                candidates_identity: "",
                graduation: "",
                school_city: this.improveInfo.school_city,
                school_province: this.improveInfo.school_province,
                school_type: "",
                middle_school: "",
                width: "50%",
            };
        },
        userCancel() {
            let crowd = this.improveInfo.crowd;
            this.dialogList = {
                type: "A",
                isTrue: true,
                province: "",
                title: "身份信息",
                button: "",
                save: false,
                remove: true,
                cancel: false,
                disabled: true,
                disabledEdit: false,
                crowd: crowd == 1 ? "学生" : crowd == 2 ? "家长" : "",
                candidates_identity: this.improveInfo.candidates_identity,
                graduation: this.improveInfo.graduation,
                school_city: this.improveInfo.school_city,
                school_province: this.improveInfo.school_province,
                school_type: this.improveInfo.school_type,
                middle_school: this.improveInfo.middle_school,
                width: "50%",
            };
        },
    },
    mounted() {
        if (store.state.user.token) {
            this.is_userInfo = true;
            this.getUserInfo();
        } 
        // this.getJurisdiction();
    },
    created() {},
};
</script>
<style lang="scss">
.newTopFixed {
    height: 60px;
    width: 1200px;
    margin: 0 auto;
    background: #fff;

    .left {
        .headerLeftImg {
            width: 21px;
            height: 25px;
        }
        .leftProvince {
            padding: 0 10px;
            cursor: pointer;
            // position: relative; /* 使伪元素相对于该元素定位 */
            // &::after {
            //   content: "";
            //   display: block;
            //   $w: 6px;
            //   width: 0; /* 设置宽度为 0，以便通过边框来形成三角形 */
            //   height: 0; /* 设置高度为 0 */
            //   border-left: $w solid transparent; /* 左侧透明边框 */
            //   border-right: $w solid transparent; /* 右侧透明边框 */
            //   border-top: $w solid #000; /* 上侧黑色边框，形成倒三角 */
            //   position: absolute;
            //   top: $w;
            //   right: -10px;
            // }
        }
    }
    .right {
        .fixedItemActive {
            color: #3c78ff;
            border-bottom: 4px solid #3c78ff;
            cursor: pointer;
        }
        .fixedItem {
            border-bottom: 4px solid #fff;
            cursor: pointer;
            &:hover{
                color: #3c78ff;
            }
        }
        .rightLogin {
            padding: 8px 15px;
            border-radius: 20px;
            border: 1px solid #3c78ff;
            cursor: pointer;
            &:hover{
                color: #3c78ff;
            }
        }
        .logo {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            cursor: pointer;
        }
        .pointer {
            cursor: pointer;
        }

        .pointer:hover {
            color: #e84c33;
        }
    }
}
.province_pop_up {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.4);
    .provinceBox {
        width: 60%;
        background: #fff;
    }
}
</style>